import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { keys } from "../api/query-registry";
import { hkToday } from "./useDailyLog";

export interface AgendaDueResident {
  id: string;
  name: string;
  bed: string | null;
  homeId: string;
  homeName: string;
  nextIcpDate: string | null;
  icpFillStatus: "pending_ax" | "ax_done_awaiting_form" | "form_available" | "filled" | null;
  overdue: boolean;
  dueSoon: boolean;
  workWindowToday: boolean;
  deepLink: string | null;
}

export interface AgendaShift {
  homeId: string;
  homeName: string;
  startTime: string;
  endTime: string;
  marker: string | null;
}

export interface AgendaTodo {
  id: string;
  title: string;
  dueDate: string;
  status: string;
  source: string;
  residentId: string | null;
}

export interface AgendaChecklist {
  id: string;
  title: string;
  dueDate: string;
}

export interface AgendaHome {
  homeId: string;
  homeName: string;
  startTime: string;
  endTime: string;
  marker: string | null;
  dueNow: AgendaDueResident[];
  todosDue: AgendaTodo[];
  checklistsDue: AgendaChecklist[];
}

export interface Agenda {
  date: string;
  restDay: boolean;
  shifts: AgendaShift[];
  homes: AgendaHome[];
  overdueAnywhere: AgendaDueResident[];
  totals: { overdue: number; dueSoon: number; openTodos: number; dueToday: number };
}

export function useAgenda() {
  const today = hkToday();
  return useQuery({
    queryKey: keys.agenda(today),
    queryFn: () => api<Agenda>("/api/agenda/today"),
    staleTime: 30_000,
  });
}
